import React from "react"
import Seo from "../../components/seo"
import Layout from "../../components/layout"
import KeyMethodLink from "../../components/key-method-link"
import { Link } from "gatsby"
import "../../styles/pc/page/key_method.scss"
import "../../styles/sp/page/key_method.scss"

export default function Communityship() {
  return (
    <Layout>
      <Seo
        type="article"
        title="それぞれのKeyMethodの紹介 コミュニティシップ経営"
        description=""
        bobyClassName="menu20"
        path="key-method/communityship"
      />
      <div className="wrapper">
        {/*//////////////////////////////* ↓パンくずリスト * //////////////////////////////*/}
        <div className="breadcrumb">
          <Link to="/">Home</Link>　/　<Link to="/philosophy#key_method_ttl">key-method</Link>　/　<Link to="/key-method/communityship" className="current">コミュニティシップ経営</Link>
        </div>
        {/*//////////////////////////////* ↑パンくずリスト * //////////////////////////////*/}

        {/*//////////////////////////////* ↓タイトル * //////////////////////////////*/}
        <div className="catch1">
          <div className="catch1_in">
            <div className="catch_title">
              <h2 className="maintitle"><span>Key Method</span></h2>
              <p className="subtitle"><span>キーメソッド</span></p>
            </div>
          </div>{/* catch_in */}
        </div>{/* /catch1 */}
        {/*//////////////////////////////* ↑タイトル * //////////////////////////////*/}
        <div className="wrapper_contents">
          <div className="main">
            {/*//////////////////////////////* ↓コンテンツ01 * //////////////////////////////*/}
            <div className="contents contents_wrap">
              <div className="contents_in">
                <div className="padding_sp">{/* スマホのみ隙間 */}
                  <div className="wrap_box w670">
                    <div className="inner_title">
                      <div className="inner_title_in">
                        <h5 className="maintitle_left"><span>コミュニティシップ経営</span></h5>
                      </div>
                    </div>
                    <div className="cnt_box">
                      <p>ヘンリー・ミンツバーグ教授が、個人主義的な価値観とアメリカ流リーダーシップが支配的になったことで、組織にとって最も重要な「<span className="redBold">コミュニティ精神</span>」が失われつつあると指摘しています。</p>
                      <p>個人主義の中で勝ち上がったリーダーたちは、自分が特別な存在であると考え、現場への関心を失い、乖離していく。</p>
                      <p>同時に、リーダーになれなかった人たちは、自分の位置づけに自信が持てず、経営への関心を失い、仕事へのやる気も奪われていく。</p>
                      <p>こうした経営を続けていて、本当に組織全体が生み出す価値が高まっていくのでしょうか。<span className="redBold">自信を失い、委縮する人ばかりを生み出す経営</span>が、組織全体としての成長を阻害しているではないでしょうか。</p>
                      <p>一人ひとりが輝き、<span className="redBold">主役感</span>が持てる会社にしたい。お互いのために知恵を出し合い、協力し合うことが喜びになる会社にしたい。<span className="redBold">みんながリーダー、みんながメンバー</span>という意識で、<span className="redBold">経営目線と現場目線をみんながもって働ける</span>会社にしたい・・・。</p>
                      <p>そのためには、ミンツバーグ教授の主張している<span className="greenBold">コミュニティシップ経営</span>への転換が必要なのではないかと考えています。</p>
                      <p>高橋克徳も、個人主義でも集団主義でもない、新たな基本原理が、組織を支えていく必要があると主張してきました。それを彼は、<span className="redBold">関係主義</span>と言っています。</p>
                      <p>一人ひとりがお互いの関係性を大切に、コミュニティシップという概念が組織に活力を生む。そんな経営への転換を、ジェイフィールは支援したいと考えます。</p>
                      <p>ジェイフィール自体の経営も、こうした考え方に沿って大きな転換をしました。全員が経営者意識を持てるように、社長、副社長、執行役員などの階層をなくし、状況によっては自分が経営者だという意識で働く組織づくりを行っていこうと思っています。</p>
                      <p>ぜひ、一緒に、新しい経営の在り方を模索してみませんか。</p>
                    </div>
                  </div>
                </div>{/* padding_sp スマホのみ隙間 */}
              </div>{/* contents_in */}
            </div>{/* /contents */}
            {/*//////////////////////////////* ↑コンテンツ01 * //////////////////////////////*/}
            <KeyMethodLink />
          </div>{/* main */}
          <div className="page_title fixed">
            <div className="right_page_ttl"><span className="vertical">Key Method - </span><span className="txt">キーメソッド</span></div>
          </div>{/* right page_title */}
        </div>{/*wrapper_contents*/}
      </div>{/*wrapper*/}
    </Layout>
  )
}
